import { useSelector } from 'react-redux';

export const MakeFields = () => {
  const { rut, orderId, purchaseDate, cud, sku } = useSelector(
    (state) => state.issuesSlice,
  );

  return [
    {
      name: 'cud',
      label: 'Cud',
      disabled: true,
      required: false,
      value: cud,
      hidden: true,
    },
    {
      name: 'sku',
      label: 'SKU',
      disabled: true,
      required: true,
      value: sku,
      hidden: true,
    },
    {
      name: 'orderId',
      inputAdornment: '',
      label: 'N° de orden de compra',
      textArea: '',
      disabled: true,
      required: true,
      value: orderId,
      hidden: true,
    },
    {
      name: 'rut',
      inputAdornment: '',
      label: 'RUT',
      textArea: '',
      disabled: true,
      required: true,
      helper: 'Sin puntos, pero con guión Ej: 12345678-9',
      value: rut,
    },
    {
      name: 'purchaseDate',
      inputAdornment: '',
      label: 'Fecha de compra',
      textArea: '',
      disabled: true,
      required: true,
      value: purchaseDate,
    },
    {
      name: 'clientName',
      inputAdornment: '',
      label: 'Nombre completo',
      textArea: '',
      disabled: false,
      required: true,
    },
    {
      name: 'phone',
      inputAdornment: '',
      label: 'Teléfono',
      textArea: '',
      disabled: false,
      required: true,
      helper: 'Ingresar 9 dígitos',
    },
    {
      name: 'email',
      inputAdornment: '',
      label: 'Correo',
      textArea: '4',
      disabled: false,
      required: true,
    },
    {
      name: 'pickupId',
      inputAdornment: '',
      label: 'Rut de quien retira',
      disabled: false,
      required: true,
      helper: 'Sin puntos, pero con guión Ej: 12345678-9',
    },
    {
      name: 'pickupName',
      inputAdornment: '',
      label: 'Nombre completo de quien retira',
      disabled: false,
      required: true,
    },
    {
      name: 'newEmail',
      inputAdornment: '',
      label: 'Correo de quien retira',
      disabled: false,
      required: true,
    },
    {
      name: 'comment',
      multiline: true,
      rows: 4,
      inputAdornment: '',
      label: 'Escribir comentario',
      textArea: 'Escribir comentario',
      disabled: false,
      required: false,
      helper: '',
    },
  ];
};
